/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-item-loop');
};

Shopify.formatAedCartMoney = function(cents) {
  var formattedPrice = Shopify.formatMoney(cents, "AED {{amount}}");
  var amount = formattedPrice.replace(/AED/g, '').trim();
  return '<span class="aed-price" aria-label="AED ' + amount + '">' +
    '<span class="aed-symbol" aria-hidden="true"></span>' +
    '<span class="aed-amount">' + amount + '</span>' +
  '</span>';
};

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {

        if (key === 'items') {
      
          if (value.length) {
            jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").css({"display": "block"});
            jQuery(".cart-tempty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            var removeLabel = (window.QtySpinnerI18n && window.QtySpinnerI18n.removeFromCart) || 'Удалить товар из корзины';
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              // Kept in exact sync with snippets/mini-cart.liquid's initial
              // server-rendered markup — same classes, same controls,
              // so the mini-cart behaves identically before and after
              // any AJAX cart update.
              jQuery('<li class="cart-item"><div class="cart-image"><a href="' + item.url + '"><img src="' + item.image + '" alt="" class="img-fluid"></a></div><div class="cart-title"><h6><a href="' + item.url + '">' + item.title.substring(0, 50) + '</a></h6><div class="cart-pro-info"><div class="cart-qty-price"><span class="price-box"><span class="new-price">' + Shopify.formatAedCartMoney(item.price) + '</span></span></div><div class="mini-cart-controls"><div class="mini-cart-qty" data-variant-id="' + item.variant_id + '"><button class="mini-cart-qty__minus" type="button" aria-label="&minus;">&#8722;</button><span class="mini-cart-qty__value">' + item.quantity + '</span><button class="mini-cart-qty__plus" type="button" aria-label="+">+</button></div><button class="mini-cart-remove" type="button" data-variant-id="' + item.variant_id + '" aria-label="' + removeLabel + '"><i class="icon-trash icons" aria-hidden="true"></i></button></div></div></div></li>').appendTo(table);
              
            });
          }
          else {
            jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").css({"display": "none"});
      jQuery(".cart-tempty-title").css({"display": "block"});
          }
        }
      });
    }
  }
  
  jQuery(".subtotal-price").html(Shopify.formatAedCartMoney(cart.total_price));
  jQuery(".bigcounter").html(cart.item_count);
   if(cart.item_count > 1){
   jQuery('.cart-count-desc.condition').text('продукта'); 
  }else{
    jQuery('.cart-count-desc.condition').text('продукт');
  }

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};